/** Default public byline for BOOTH Articles. */
export const BLOG_AUTHOR = {
  name: "Paul Panama",
  role: "Marketing & Barbershop Journalist",
  publication: "BOOTH Articles",
  initials: "PP",
  avatar: "booth",
} as const

/** Founder byline — same booth mark; every BOOTH byline carries it now. */
export const BLOG_FOUNDER = {
  name: "Eduardo Ramos",
  role: "Founder",
  publication: "BOOTH Articles",
  initials: "ER",
  avatar: "booth",
} as const

/** Team byline — for pieces in the company's voice, where the founder
    appears in the third person rather than as the writer. On the page it
    prints no name, only the BOOTH mark and the date; the brand implies the
    author. The name is for metadata and llms.txt. */
export const BLOG_TEAM = {
  name: "BOOTH",
  role: "BOOTH",
  publication: "BOOTH Articles",
  initials: "B",
  avatar: "booth",
  organization: true,
} as const

export type BlogAuthorAvatar = "initials" | "booth"

export type BlogAuthor = {
  name: string
  role: string
  publication?: string
  initials: string
  avatar?: BlogAuthorAvatar
  /** Credited to BOOTH itself rather than a person: no printed name, and an
      Organization author in structured data. */
  organization?: boolean
}

export type BlogArticleAuthor = "editor" | "founder" | "team"

const AUTHORS: Record<BlogArticleAuthor, BlogAuthor> = {
  editor: BLOG_AUTHOR,
  founder: BLOG_FOUNDER,
  team: BLOG_TEAM,
}

export function resolveBlogAuthor(key?: BlogArticleAuthor): BlogAuthor {
  return AUTHORS[key ?? "editor"]
}
